// router.js
import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router';
import HomePage from "./views/home/homePage.vue";
import { getUrlLink } from './api/index.js';

// 定义路由
export const routes = [
  {
    path: '/', component: HomePage,
    hidden:false,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/solutions', component: HomePage, 
    hidden:false,
    meta: {
      title: '解决方案'
    }
  },
  {
    path: '/scenarios', component: HomePage, 
    hidden:false,
    meta: {
      title: '应用场景'
    }
  },
  {
    path: '/products', component: HomePage,
    hidden:false,
     meta: {
      title: '产品矩阵'
    }
  },
  {
    path: '/about', component: HomePage,
    hidden:false,
    meta: {
      title: '关于我们'
    }
  },
  { path: '/applet', component: HomePage,
    hidden:true,
   },
  { path: '/*', component: HomePage,hidden:true, },
];

// 创建router实例
const router = createRouter({
  history: createWebHistory("/"),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  }
});

export default router;
